const src = import.meta.ROLLUP_FILE_URL_lmExdBtjnYpNskmFJV_eKw;
export default {
  src,
  srcSet: src + " " + 4283 + "w",
  width: 4283,
  height: 6446,
};